module.exports = __webpack_public_path__ + "static/media/white-box.150c0816.svg";